import React, { useState, useEffect } from 'react'
import styled from 'styled-components';

const Label = styled.label`
      position: relative;
      display: inline-block;
      width: 60px;
      height: 34px;
      input {
        opacity: 0;
        width: 0;
        height: 0;
      }
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
        &:before {
          position: absolute;
          content: "";
          height: 26px;
          width: 26px;
          left: 4px;
          bottom: 4px;
          background-color: white;
          -webkit-transition: .4s;
          transition: .4s;
        }
      }
      input:checked + .slider {
        background-color: #3F76E6;
      }

      input:focus + .slider {
        box-shadow: 0 0 1px #3F76E6;
      }

      input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
        }
      /* Rounded sliders */
      .slider.round {
        border-radius: 34px;
      }

      .slider.round:before {
        border-radius: 50%;
      } 
`;

const Checkbox = ({
  onChange = () => {},
  checked = false
}) => {
  useEffect(() => {
    setCheckBoxState(checked)
  }, [checked])
  const [checkBoxState, setCheckBoxState] = useState(checked)
  return (
    <Label>
      <input type="checkbox" onChange={(e) => {
        onChange(e.target.checked)
        setCheckBoxState(e.target.checked)
      }} checked={checkBoxState} />
      <span className="slider round"></span>
    </Label>
  )
}

export default Checkbox
